import { useLendingApplicationID } from "@lending/hooks/useLendingApplicationID";
import { useApi } from "@lending/lib/api";

const DEFAULT_OPTIONS = {
  enabled: true,
} as const;

interface Options {
  applicationUuid?: string;
  enabled?: boolean;
  refetchInterval?: number;
}
function useGetAutoLoanApplicationQuery(optionsProp: Options = DEFAULT_OPTIONS) {
  const $api = useApi();
  const storeApplicationId = useLendingApplicationID();

  const options = { ...DEFAULT_OPTIONS, ...optionsProp };

  const { applicationUuid, enabled, refetchInterval } = options;
  const resolvedApplicationId = applicationUuid ?? storeApplicationId;

  return $api.useQuery(
    "get",
    "/v2/lending/vehicle_loan_applications/{uuid}/",
    {
      params: {
        path: {
          uuid: resolvedApplicationId,
        },
        // @ts-expect-error schema does not include query
        query: {
          vehicle_type: "car",
        },
      },
    },
    {
      enabled: Boolean(resolvedApplicationId) && enabled,
      refetchInterval,
    }
  );
}

export { useGetAutoLoanApplicationQuery };
